import React from 'react';
import { Users, Leaf, TrendingUp, IndianRupee } from 'lucide-react';

const Stats = () => {
  const stats = [
    {
      icon: Users,
      number: '10K+',
      label: 'Climate-Smart Farmers',
      sublabel: 'Growing daily'
    },
    {
      icon: Leaf,
      number: '2.5M',
      label: 'Tons CO₂ Sequestration',
      sublabel: '(2025-2026) in pipeline'
    },
    {
      icon: TrendingUp,
      number: '40%',
      label: 'Soil Improvement',
      sublabel: 'Average boost'
    },
    {
      icon: IndianRupee,
      number: '₹15K+',
      label: 'Monthly Earnings',
      sublabel: 'Per farmer avg'
    }
  ];

  return (
    <section className="pt-20 pb-0 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div 
                key={index} 
                className="text-center space-y-3 p-6 rounded-2xl bg-gray-50 border border-neo-emerald/20 hover:border-neo-emerald/40 transition-all duration-300 hover:shadow-lg hover:shadow-neo-emerald/20"
              >
                <div className="flex justify-center">
                  <div className="w-12 h-12 bg-neo-emerald/20 rounded-full flex items-center justify-center">
                    <Icon className="w-6 h-6 text-neo-emerald" />
                  </div>
                </div>
                <h3 className="text-4xl font-heading font-bold text-neo-black">{stat.number}</h3>
                <p className="text-neo-black font-semibold font-body">{stat.label}</p>
                <p className="text-sm text-neo-gray font-body">{stat.sublabel}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Stats;
